module.exports = __webpack_public_path__ + "static/img/20010 (5).8118fbb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20010 (5).webp
// module id = wK+o
// module chunks = 14